// extracted by mini-css-extract-plugin
module.exports = {"Login":"Signup_Login__2nTGu","FormContainer":"Signup_FormContainer__266cR"};